export const markets = {
  en: {
    "markets.averageCryptoRsi": "Average Crypto RSI",
    "markets.oversold": "Oversold",
    "markets.neutral": "Neutral",
    "markets.overbought": "Overbought",

    "markets.bitcoinDominanceTitle": "Bitcoin Dominance",
    "markets.bitcoinDominanceMarketCap": "Market Cap",
    "markets.fearGreed": "Fear & Greed",
    "markets.bitcoin": "Bitcoin",
    "markets.altcoin": "Altcoin",
    "markets.bitcoinDominanceOther": "Other",

    "markets.cryptoMarketCapTitle": "Crypto Market Cap",
    "markets.cryptoMarketCapOverview": "Overview",
    "markets.cryptoMarketCapBreakdown": "Breakdown",
    "markets.cryptoMarketCapMarketCap": "Market Cap",
    "markets.cryptoMarketCapVolume": "Volume",
    "markets.cryptoMarketCapBitcoin": "Bitcoin",
    "markets.cryptoMarketCapEthereum": "Ethereum",
    "markets.cryptoMarketCapOthers": "Others",
    "markets.cryptoMarketCap30D": "30D",
    "markets.cryptoMarketCap1Y": "1Y",
    "markets.cryptoMarketCapAll": "All",
    "markets.months.jan": "Jan",
    "markets.months.feb": "Feb",
    "markets.months.mar": "Mar",
    "markets.months.apr": "Apr",
    "markets.months.may": "May",
    "markets.months.jun": "Jun",
    "markets.months.jul": "Jul",
    "markets.months.aug": "Aug",
    "markets.months.sep": "Sep",
    "markets.months.oct": "Oct",
    "markets.months.nov": "Nov",
    "markets.months.dec": "Dec",

    "markets.marketCapTitle": "Market Cap",
    "markets.tradingVolumeTitle": "Trading Volume",
    "markets.extremeFear": "Extreme fear",

    "markets.tabs.favorites": "Favorites",
    "markets.tabs.all": "All",
    "markets.segments.all": "All Networks",
    "markets.tabs.newListings": "New Listings",

    "markets.table.pair": "Pair",
    "markets.table.price": "Price",
    "markets.table.change": "24h Change",
    "markets.table.marketCap": "Market Cap",
    "markets.table.volume": "24h Volume",
    "markets.table.chart": "Chart",
    "markets.table.action": "Action",
    "markets.more": "More",
    "markets.pair_unavailable": "Unavailable",
    "markets.availableToTrade": "Available to trade",

    "markets.noCoins": "No coins to display right now",
    "markets.noFavorites": "No favorite coins yet. Tap the star to add assets.",
  },

  ru: {
    "markets.averageCryptoRsi": "Средний RSI крипторынка",
    "markets.oversold": "Перепроданный",
    "markets.overbought": "Перекупленный",
    "markets.neutral": "Нейтральный",

    "markets.bitcoinDominanceTitle": "Доминирование Bitcoin",
    "markets.bitcoinDominanceMarketCap": "Рыночная капитализация",
    "markets.fearGreed": "Страх и жадность",
    "markets.bitcoin": "Биткоин",
    "markets.altcoin": "Альткоин",
    "markets.bitcoinDominanceOther": "Другое",

    "markets.cryptoMarketCapTitle": "Капитализация крипторынка",
    "markets.cryptoMarketCapOverview": "Обзор",
    "markets.cryptoMarketCapBreakdown": "Распределение",
    "markets.cryptoMarketCapMarketCap": "Капитализация",
    "markets.cryptoMarketCapVolume": "Объём",
    "markets.cryptoMarketCapBitcoin": "Bitcoin",
    "markets.cryptoMarketCapEthereum": "Ethereum",
    "markets.cryptoMarketCapOthers": "Остальные",
    "markets.cryptoMarketCap30D": "30D",
    "markets.cryptoMarketCap1Y": "1Y",
    "markets.cryptoMarketCapAll": "Все",
    "markets.months.jan": "Янв",
    "markets.months.feb": "Фев",
    "markets.months.mar": "Мар",
    "markets.months.apr": "Апр",
    "markets.months.may": "Май",
    "markets.months.jun": "Июн",
    "markets.months.jul": "Июл",
    "markets.months.aug": "Авг",
    "markets.months.sep": "Сен",
    "markets.months.oct": "Окт",
    "markets.months.nov": "Ноя",
    "markets.months.dec": "Дек",

    "markets.marketCapTitle": "Капитализация рынка",
    "markets.tradingVolumeTitle": "Объем торгов",
    "markets.extremeFear": "Экстремальный страх",

    "markets.tabs.favorites": "Избранное",
    "markets.tabs.all": "Все",
    "markets.segments.all": "Все сети",
    "markets.tabs.newListings": "Новые листинги",

    "markets.table.pair": "Пара",
    "markets.table.price": "Цена",
    "markets.table.change": "Изменение за 24ч",
    "markets.table.marketCap": "Капитализация",
    "markets.table.volume": "Объём за 24ч",
    "markets.table.chart": "График",
    "markets.table.action": "Действие",
    "markets.more": "Больше",
    "markets.pair_unavailable": "Недоступно",
    "markets.availableToTrade": "Доступные для торговли",

    "markets.noCoins": "Сейчас нет монет для отображения",
    "markets.noFavorites":
      "Пока нет избранных монет. Нажмите на звезду, чтобы добавить.",
  },

  es: {
    "markets.averageCryptoRsi": "RSI promedio del mercado cripto",
    "markets.oversold": "Sobrevendido",
    "markets.overbought": "Sobrecomprado",
    "markets.neutral": "Neutral",

    "markets.bitcoinDominanceTitle": "Dominancia de Bitcoin",
    "markets.bitcoinDominanceMarketCap": "Capitalización de mercado",
    "markets.fearGreed": "Miedo y codicia",
    "markets.bitcoin": "Bitcoin",
    "markets.altcoin": "Altcoin",
    "markets.bitcoinDominanceOther": "Otros",

    "markets.cryptoMarketCapTitle": "Capitalización del mercado cripto",
    "markets.cryptoMarketCapOverview": "Resumen",
    "markets.cryptoMarketCapBreakdown": "Desglose",
    "markets.cryptoMarketCapMarketCap": "Capitalización",
    "markets.cryptoMarketCapVolume": "Volumen",
    "markets.cryptoMarketCapBitcoin": "Bitcoin",
    "markets.cryptoMarketCapEthereum": "Ethereum",
    "markets.cryptoMarketCapOthers": "Otros",
    "markets.cryptoMarketCap30D": "30D",
    "markets.cryptoMarketCap1Y": "1Y",
    "markets.cryptoMarketCapAll": "Todo",
    "markets.months.jan": "Ene",
    "markets.months.feb": "Feb",
    "markets.months.mar": "Mar",
    "markets.months.apr": "Abr",
    "markets.months.may": "May",
    "markets.months.jun": "Jun",
    "markets.months.jul": "Jul",
    "markets.months.aug": "Ago",
    "markets.months.sep": "Sep",
    "markets.months.oct": "Oct",
    "markets.months.nov": "Nov",
    "markets.months.dec": "Dic",

    "markets.marketCapTitle": "Capitalización de mercado",
    "markets.tradingVolumeTitle": "Volumen de negociación",
    "markets.extremeFear": "Miedo extremo",

    "markets.tabs.favorites": "Favoritos",
    "markets.tabs.all": "Todo",
    "markets.segments.all": "Todas las redes",
    "markets.tabs.newListings": "Nuevos listados",

    "markets.table.pair": "Par",
    "markets.table.price": "Precio",
    "markets.table.change": "Cambio 24h",
    "markets.table.marketCap": "Capitalización",
    "markets.table.volume": "Volumen 24h",
    "markets.table.chart": "Gráfico",
    "markets.table.action": "Acción",
    "markets.more": "Más",
    "markets.pair_unavailable": "No disponible",
    "markets.availableToTrade": "Disponibles para operar",

    "markets.noCoins": "No hay monedas para mostrar en este momento",
    "markets.noFavorites":
      "Aún no hay monedas favoritas. Pulsa la estrella para agregar activos.",
  },

  ua: {
    "markets.averageCryptoRsi": "Середній RSI крипторинку",
    "markets.oversold": "Перепроданий",
    "markets.overbought": "Перекуплений",
    "markets.neutral": "Нейтральний",

    "markets.bitcoinDominanceTitle": "Домінування Bitcoin",
    "markets.bitcoinDominanceMarketCap": "Ринкова капіталізація",
    "markets.fearGreed": "Страх і жадібність",
    "markets.bitcoin": "Біткоїн",
    "markets.altcoin": "Альткоїн",
    "markets.bitcoinDominanceOther": "Інше",

    "markets.cryptoMarketCapTitle": "Капіталізація крипторинку",
    "markets.cryptoMarketCapOverview": "Огляд",
    "markets.cryptoMarketCapBreakdown": "Розподіл",
    "markets.cryptoMarketCapMarketCap": "Капіталізація",
    "markets.cryptoMarketCapVolume": "Обсяг",
    "markets.cryptoMarketCapBitcoin": "Bitcoin",
    "markets.cryptoMarketCapEthereum": "Ethereum",
    "markets.cryptoMarketCapOthers": "Інші",
    "markets.cryptoMarketCap30D": "30Д",
    "markets.cryptoMarketCap1Y": "1Р",
    "markets.cryptoMarketCapAll": "Всі",
    "markets.months.jan": "Січ",
    "markets.months.feb": "Лют",
    "markets.months.mar": "Бер",
    "markets.months.apr": "Кві",
    "markets.months.may": "Тра",
    "markets.months.jun": "Чер",
    "markets.months.jul": "Лип",
    "markets.months.aug": "Сер",
    "markets.months.sep": "Вер",
    "markets.months.oct": "Жов",
    "markets.months.nov": "Лис",
    "markets.months.dec": "Гру",

    "markets.marketCapTitle": "Капіталізація ринку",
    "markets.tradingVolumeTitle": "Обсяг торгів",
    "markets.extremeFear": "Екстремальний страх",

    "markets.tabs.favorites": "Улюблені",
    "markets.tabs.all": "Всі",
    "markets.segments.all": "Всі мережі",
    "markets.tabs.newListings": "Нові лістинги",

    "markets.table.pair": "Пара",
    "markets.table.price": "Ціна",
    "markets.table.change": "Зміна за 24г",
    "markets.table.marketCap": "Капіталізація",
    "markets.table.volume": "Обсяг за 24г",
    "markets.table.chart": "Графік",
    "markets.table.action": "Дія",
    "markets.more": "Більше",
    "markets.pair_unavailable": "Недоступно",
    "markets.availableToTrade": "Доступні для торгівлі",

    "markets.noCoins": "Наразі немає монет для відображення",
    "markets.noFavorites":
      "Поки немає улюблених монет. Натисніть на зірку, щоб додати активи.",
  },
};

export default markets;
